import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface SessionParameter extends ApiParameter {
    customerNumber: string;
    callbackURL: string;
    onError?: (errorMessage: string) => void;
}

export interface SessionApiModel { }

const sessionUrl = "/api/v1/PayNowSession/SSO";

export async function getUnifiedARSession(
    parameter: SessionParameter & HasOnSuccess<SessionParameter> & HasOnComplete<SessionParameter>,
) {
    const apiParameter = { ...parameter };
    fetch(`/api/v1/PayNowSession/SSO?customerNumber=${parameter.customerNumber}&callbackUrl=${parameter.callbackURL}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json', // Set the appropriate content type for your request
        },
        body: JSON.stringify({ apiParameter }),
    })
        .then(response => {
            // Access response headers
            const headers = response.headers;
            // Get a specific header value
            const redirectURL = headers.get('Location') ?? "/";
            //Redirect user to Location value recieved in headers.
            window.open(redirectURL, '_blank');
            return response.json();
        })
}